<div fxLayout="column" fxLayoutAlign="start start" class="w-100 h-100" fxFlex>
    @if (filterFields?.length || (showImport || showExport)) {
        <af-filter #filter
                   class="w-100 mt-24"
                   [filterFields]="filterFields"
                   (filterListener)="filterTable($event)"
                   [placeholderContext]="placeholderContext"
                   [chips]="chips"
                   [filterEvent]="filterEvent"
                   [exportImportMode]="exportImportMode"
                   [showImport]="showImport"
                   [showExport]="showExport"
                   [showSearchBar]="showSearchBar"
                   [hasContent]="hasFilterContent"
                   [chipsFormControlName]="chipsFormControlName"
                   [allowSearchSpaces]="allowSearchSpaces">
            <ng-content select="[FilterContent]"/>
        </af-filter>
    }

    @if (showTable && dataSource?.length) {
        <af-table #table
                  class="w-100 h-100 overflow-x-scroll"
                  fxFlex
                  [class.mt-24]="!totalElementsTranslationKey"
                  [class.mt-8]="totalElementsTranslationKey"
                  [dataSource]="dataSource"
                  [addTranslationPrefix]="addTableTranslationPrefix"
                  [columnTranslationPrefixes]="columnTranslationPrefixes"
                  [sortedBy]="tableEvent.sortBy"
                  (sortByListener)="sortBy($event)"
                  [totalElementsTitle]="totalElementsTranslationKey | translate : {totalElements: totalElements}"/>
    }
    @if (!dataSource?.length) {
        <div class="w-100 h-100">
            <ui-kit-empty-state class="mt-24 w-100"
                                [icon]="emptyStateIcon"
                                [spinnerIds]="spinnerIds"
                                [title]="emptyStateTitle"
                                [subtitle]="emptyStateSubtitle"
                                backgroundColor="light"
                                [buttonLabel]="emptyStateButton"
                                (clickListener)="onEmptyStateClick()"
                                [items]="dataSource"/>
        </div>
    }
    @if (showPaginator) {
        <af-paginator #paginator
                      fxFlexAlign="end"
                      [spinnerIds]="['initial','filter']"
                      class="mt-16 no-select"
                      (scrollEmitter)="table?.scrollTable($event)"
                      (pageChangeListener)="pageChanges($event)"
                      [currentPageEvent]="pageEvent"
                      [totalElements]="totalElements"/>
    }
</div>
